import React, { Component } from 'react';
import { connect } from 'react-redux';

class Main extends Component {
	render() {
		const { intl, isExpanded, toggleApiList } = this.props;

		return (
			<div>
				<ul>
					<li>
						<span>
							<b className="font-proxima-nova-semibold">
								campaign_id
							</b> - {intl('ID кампании (берется из id потока, например 500401)')}
						</span>
					</li>
					<li>
						<span>
							<b className="font-proxima-nova-semibold">ip</b> - {
								intl('IP клиента (критично передавать корректный IP для правильной работы системы ...')
							}
						</span>
					</li>
					<li>
						<span>
							<b className="font-proxima-nova-semibold">country_code</b> - {intl('код страны')}
						</span>
					</li>
					<li>
						<span>
							<b className="font-proxima-nova-semibold">name</b> - {intl('имя клиента')}
						</span>
					</li>
					<li>
						<span>
							<b className="font-proxima-nova-semibold">phone</b> - {intl('телефон клиента')}
						</span>
					</li>
					<li>
						<span>
							<b className="font-proxima-nova-semibold">sid1 - sid5</b> - {intl('опциональные поля')}
						</span>
					</li>
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">
									extra_phone</b> - {intl('дополнительный телефон (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">address</b> - {intl('адрес клиента (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">mail</b> - {intl('еmail клиента (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">street</b> - {intl('улица (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">house</b> - {intl('дом (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">room</b> - {intl('квартира (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">zip</b> - {intl('почтовый индекс (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">city</b> - {intl('город (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b
									className="font-proxima-nova-semibold"
								>comment</b> - {intl('комментарий, любая дополнительная текстовая информация (опционально)')}
							</span>
						</li>
					}
					{
						isExpanded &&
						<li>
							<span>
								<b className="font-proxima-nova-semibold">redirect_url</b> - {
									intl('URL, на которую следует перенаправить клиента после приема заказа ...')
								}
							</span>
						</li>
					}
				</ul>
				<button
					className="button yellow-btn font-proxima-nova-semibold apply-btn expand-button"
					onClick={toggleApiList}
				>
					{ isExpanded ? '-' : '+' }
				</button>
			</div>
		);
	}
}

export default connect(state => ({ isExpanded: state.userApi.isExpanded }))(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/user-api/components/tracker-fields-list.js